namespace Ir.Components.ReportDesigner.ReportFieldDesignerProperties {

    let popoverComponent: DevExpress.ui.dxPopover = null;
    let koField: KnockoutObservable<ReportField> | KnockoutObservable<MetricField>;
    let widgetType: WidgetType;
    let restoreComparisonMetricsVisible = ko.observable(false);
    let onHidden: Function;
    let metricArray: KnockoutObservableArray<MetricField>;
    let groupingTypeOptions = ko.observableArray();
    let reportConfig: ReportConfig;
    let groupFields: KnockoutObservableArray<ReportField>;

    interface IShowParams {
        field: ReportField | MetricField, 
        widgetType: WidgetType, 
        $target: JQuery<HTMLElement>, 
        metricArray: KnockoutObservableArray<MetricField>, 
        groupingTypeOptions: Array<any>, 
        onPropertiesHidden?: Function,
        restoreComparisonMetricsVisible: KnockoutComputed<boolean>,
        reportConfig: ReportConfig;
        groupFields: KnockoutObservableArray<ReportField>;
        reportDesigner: Ir.Components.ReportDesigner.ReportDesigner.IViewModel;
    }

    export function show(config: IShowParams) {

        widgetType = config.widgetType;
        onHidden = config.onPropertiesHidden;
        groupingTypeOptions(config.groupingTypeOptions);
        restoreComparisonMetricsVisible(config.restoreComparisonMetricsVisible());
        reportConfig = config.reportConfig;
        groupFields = config.groupFields;

        metricArray = config.metricArray;
        if (popoverComponent == null) {
            koField = ko.observable(config.field);
            createPopover(config);
        }
        else {
            koField(null);
            koField(config.field);
            popoverComponent.option("title", config.field.displayNameForDesigner as any);
            popoverComponent.show(config.$target);
        }
    }
    interface IViewModel {
        field: ReportField | MetricField;
        popoverOptions: DevExpress.ui.dxPopover.Properties;
        operationSelectBoxConfig: DevExpress.ui.dxSelectBox.Properties;
        restoreComparisonMetricsButtonConfig: DevExpress.ui.dxButton.Properties;
        editExpressionButtonConfig: DevExpress.ui.dxButton.Properties;
        
        tableAndFieldName: KnockoutComputed<string>;
        renameFieldInputConfig: Ir.Components.General.TextBox.ITextBoxParams;
        allMetricsField: boolean;
        isExpression: boolean;
        isReportOrPivot: boolean;
        isReport: boolean;
        isPivot: boolean;
        isChart: boolean;
        isBubbleChart: boolean;
        isScatterChart: boolean;

        functionSelectBoxConfig: DevExpress.ui.dxSelectBox.Properties;
        formatSelectBoxConfig: DevExpress.ui.dxSelectBox.Properties;
        accountingStyleConfig: DevExpress.ui.dxSelectBox.Properties;
        decimalPlacesParams: Ir.Components.Workbook.Settings.Items.DecimalPlacesSetting.IParams;
        formattingRuleSettingParams: Ir.Components.Workbook.Settings.Items.FormattingRuleSetting.IFormattingRuleSettingParams;
        backgroundColorParams: Ir.Components.General.ColorPicker.IColorPickerParams;
        foreColorParams: Ir.Components.General.ColorPicker.IColorPickerParams;
        partitionBySwitchConfig: DevExpress.ui.dxSwitch.Properties;
        thresholdValueNumberBoxConfig: DevExpress.ui.dxNumberBox.Properties;
        thresholdColorParams: Ir.Components.General.ColorPicker.IColorPickerParams;
        showTotalValueSwitchConfig: DevExpress.ui.dxSwitch.Properties;
        showSubtotalValueSwitchConfig: DevExpress.ui.dxSwitch.Properties;
        titleAlignSelectBoxConfig: DevExpress.ui.dxSelectBox.Properties;
        valuesAlignSelectBoxConfig: DevExpress.ui.dxSelectBox.Properties;
        modeSelectBoxConfig: DevExpress.ui.dxSelectBox.Properties;
        barChartTextSelectBox: DevExpress.ui.dxSelectBox.Properties;
        barChartTextPositionSelectBox: DevExpress.ui.dxSelectBox.Properties;
        barChartColorParams: Ir.Components.General.ColorPicker.IColorPickerParams;
        barChartNegativeColorParams: Ir.Components.General.ColorPicker.IColorPickerParams;
        visibleSwitchConfig: DevExpress.ui.dxSwitch.Properties;
        yAxisSwitchConfig: DevExpress.ui.dxSwitch.Properties;
        chartTypeSelectBoxConfig: DevExpress.ui.dxSelectBox.Properties;
        serieColorParams: Ir.Components.General.ColorPicker.IColorPickerParams;
        serieStackGroupConfig: DevExpress.ui.dxNumberBox.Properties;
        serieBubbleSelectBox: DevExpress.ui.dxSelectBox.Properties;
        serieScatterSelectBox: DevExpress.ui.dxSelectBox.Properties;
        variablesTooltipParams: Ir.Components.ReportDesigner.VariablesTooltip.IVariablesTooltipParams;
    }

    interface IParams {
        field: KnockoutObservable<ReportField> | KnockoutObservable<MetricField>;
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        let self = this;
        self.field = params.field();
        self.isReportOrPivot = widgetType === WidgetType.Report || widgetType === WidgetType.Pivot;
        self.isReport = widgetType === WidgetType.Report;
        self.isPivot = widgetType === WidgetType.Pivot;
        self.isChart = widgetType === WidgetType.Chart;
        self.isBubbleChart = self.isChart && reportConfig.chartDefinition.chartType() === ChartType.Bubble;
        self.isScatterChart = self.isChart && reportConfig.chartDefinition.chartType() === ChartType.Scatter;
        configure(self, componentInfo.element);
    }

    function configure(self: IViewModel, $parent) {
        let field = self.field;
        let metricField = field as MetricField;
        let allMetricsField = field.isMetric && field.displayName() === allMetricName;
        self.allMetricsField = allMetricsField;
        let isExpression = field.isMetric && metricField.metricContainer.isExpression;
        self.isExpression = isExpression;

        let autoGroupingOptions = [
            { value: AutoGroupingEnum.None, text: " " },
            { value: AutoGroupingEnum.ByDay, text: "By Day" },
            { value: AutoGroupingEnum.ByWeek, text: "By Week" },
            { value: AutoGroupingEnum.ByWeekNumber, text: "By Week Number" },
            { value: AutoGroupingEnum.ByMonth, text: "By Month" },
            { value: AutoGroupingEnum.ByQuarter, text: "By Quarter" },
            { value: AutoGroupingEnum.ByYear, text: "By Year" },
            { value: AutoGroupingEnum.ByMonthOnly, text: "By Month Only" },
            { value: AutoGroupingEnum.ByQuarterOnly, text: "By Quarter Only" },
            { value: AutoGroupingEnum.ByWeekOnly, text: "By Week Only" },
        ];

        self.operationSelectBoxConfig = {
            value: field.groupingType,
            dataSource: groupingTypeOptions,
            displayExpr: 'text',
            valueExpr: 'value',
            width: 100,
            height: 24,
            readOnly: field.isMetric && metricField.metricContainer?.isExpression,
            onValueChanged(e) {
                if (field.dataType === DataTypeEnum.DATE && field.autoGrouping() !== AutoGroupingEnum.None && field.groupingType() !== GroupingTypeEnum.GROUP_BY) {
                    var autoGrouping = autoGroupingOptions.find(x => x.value === field.autoGrouping()).text;
                    var groupingType = Ir.Components.ReportDesigner.ReportDesignerField.allGroupingTypes.find(x => x.value === field.groupingType()).text;

                    DevExpress.ui.notify({
                        message: `Cannot have ${autoGrouping} with Operation ${groupingType}. Changed Operation to Group By.`,
                        position: {
                            my: 'left bottom',
                            at: 'left top',
                            of: e.element,
                        },
                        width: 500,
                    }, 'error', 3000);

                    //Cannot update directly here, otherwise the dxSelectBox won't update on screen
                    setTimeout(function () {
                        field.groupingType(GroupingTypeEnum.GROUP_BY);
                    }, 100);

                }
            },
        };

        self.tableAndFieldName = ko.computed(function () {
            return `[${field.fieldDisplayTableName}].[${field.fieldDisplayName}]`;
        });

        let nameElement = ko.observable();
        let variablesLegendVisible = ko.observable(false);
        self.renameFieldInputConfig = {
            text: field.displayNameForDesigner,
            width: "100%",
            onValueChanged(e) {
                if (field.isMetric && field instanceof MetricField) {
                    if (field.metricContainer.comparisonType === ComparisonMetricType.None) {
                        let metrics = metricArray();
                        let newName = e.value;
                        let oldName = e.previousValue;
                
                        let regMetaChars = /[-\\^$*+?.()|[\]{}]/g;
                        let pattern = oldName.replace(regMetaChars, '\\$&');
                        let rgx = new RegExp(`^${pattern}`);
                
                        let compMetrics = metrics.filter(x => x.isMetric && x instanceof MetricField && x.parentMetricField === field && x.metricContainer.comparisonType !== ComparisonMetricType.None && x.metricContainer.functionType() === field.metricContainer.functionType() && rgx.test(x.displayNameForDesigner()));
                        if (compMetrics.length > 0 && oldName !== newName) {
                            var result = DevExpress.ui.dialog.confirm("Do you want to rename the comparison metrics?", "Confirm renaming");
                            result.done(function(dialogResult) {
                                if (dialogResult) {
                                    compMetrics.forEach(function (comparisonMetricField) {
                                        comparisonMetricField.displayNameForDesigner(comparisonMetricField.displayNameForDesigner().replace(rgx, newName));
                                    });
                                }
                            });
                        }
                    }
                }
            },
            onFocusIn(e) {
                variablesLegendVisible(true);
            },
            onFocusOut(e) {
                variablesLegendVisible(false);
            },
            onInitialized(e) {
                nameElement(e.element);
            }
        };
                
        self.variablesTooltipParams = {
            target: nameElement as any,
            visible: ko.computed(function () {
                return variablesLegendVisible() && field.isMetric;
            }),
        };

        self.functionSelectBoxConfig = {
            value: metricField.metricContainer?.functionType,
            items: functionOptions(),
            displayExpr: 'text',
            valueExpr: 'value',
            width: self.isPivot ? 200 : 120,
            height: 24,
            onValueChanged(e) {
                let oldValue = e.previousValue as FunctionTypeEnum;
                if (e.value == FunctionTypeEnum.Rank) {
                    metricField.showTotalValue(false);
                    metricField.showSubtotalValue(false);
                    metricField.numberFormat(FieldFormatEnum.Numeric);
                    metricField.decimalPlaces(0);
                }
                else if (e.previousValue == FunctionTypeEnum.Rank) {
                    metricField.showTotalValue(true);
                    metricField.showSubtotalValue(true);
                }

                const functionType = e.value as FunctionTypeEnum;
                if (percentFunctionType.indexOf(functionType) !== -1) {
                    metricField.numberFormat(FieldFormatEnum.Percentage);
                }
                else if (metricField.metricContainer.comparisonType === ComparisonMetricType.None && (functionType === FunctionTypeEnum.AccumulatedAll || functionType === FunctionTypeEnum.Accumulated) && metricField.numberFormat() === FieldFormatEnum.Percentage) {
                    metricField.numberFormat(FieldFormatEnum.Currency);
                }

                if (field.id() !== allMetricName && field.isMetric && metricField.metricContainer.comparisonType === ComparisonMetricType.None) {
                    //Some functions cannot have comparison filters, so, they need to be removed
                    if (!Ir.Components.ReportDesigner.ComparisonFilterList.canHaveComparison(metricField, widgetType)) {
                        metricArray.remove(function (x) {
                            return x.isMetric && x.id() !== allMetricName && (x as MetricField).parentMetricField === metricField && (x as MetricField).metricContainer.comparisonType !== ComparisonMetricType.None;
                        });
                    }
                    else {
                        let metrics = metricArray();
                        //THIS CODE NEED TO BE REVIEWED, SAME METRIC WITH DIFFERENT FUNCTIONS AND COMPARISON FILTER HAVE CONFLICTS EDITING 
                        // if (metrics.filter(x => x.isMetric && x.queryName == metricField.queryName).length > 1) {
                        //     return;
                        // }

                        let comparisonMetricFields = metrics.filter(x => x.isMetric && x.id() !== allMetricName && 
                            (x as MetricField).parentMetricField === metricField && (x as MetricField).metricContainer.comparisonType !== ComparisonMetricType.None);
                        for(let comparisonMetricField of comparisonMetricFields) {
                            
                            comparisonMetricField.metricContainer.functionType(metricField.metricContainer.functionType());

                            if (comparisonMetricField.metricContainer.comparisonType !== ComparisonMetricType.PercentageVariation && 
                                (functionType === FunctionTypeEnum.AccumulatedAll || functionType === FunctionTypeEnum.Accumulated) && 
                                comparisonMetricField.numberFormat() === FieldFormatEnum.Percentage) {

                                comparisonMetricField.numberFormat(FieldFormatEnum.Currency);
                            }
                        }
                    }
                }
            },
        };

        let percentFunctionType = [
            FunctionTypeEnum.PercentOfTotal,
            FunctionTypeEnum.PercentOfRowTotal,
            FunctionTypeEnum.PercentOfRowGrandTotal,
            FunctionTypeEnum.PercentOfColumnTotal,
            FunctionTypeEnum.PercentOfColumnGrandTotal,
            FunctionTypeEnum.PercentVariation
        ];

        self.formatSelectBoxConfig = {
            value: metricField.numberFormat,
            hint: ko.computed(function() {
                return field.isMetric && metricField?.numberFormat() === null ? `Metric Format: ${FieldFormatEnum[metricField.metricContainer.metricObject.format]}` : "";
            }, metricField) as any,
            items: ko.computed(function () {
                if (!field.isMetric) {
                    return [];
                }

                let functionType = metricField.metricContainer.functionType();
                if (percentFunctionType.indexOf(functionType) !== -1) {
                    return [{ value: FieldFormatEnum.Percentage, text: "Percentage" }];
                }
                else if (metricField.metricContainer.comparisonType === ComparisonMetricType.None && (functionType === FunctionTypeEnum.AccumulatedAll || functionType === FunctionTypeEnum.Accumulated)) {
                    return [
                        { value: FieldFormatEnum.Numeric, text: "Numeric" },
                        { value: FieldFormatEnum.Currency, text: "Currency" }
                    ]
                }

                return [
                    { value: null, text: "Based on Metric" },
                    { value: FieldFormatEnum.Numeric, text: "Numeric" },
                    { value: FieldFormatEnum.Currency, text: "Currency" },
                    { value: FieldFormatEnum.Percentage, text: "Percentage" }
                ]
            }, field) as any,
            displayExpr: 'text',
            valueExpr: 'value',
            width: 120,
            height: 24,
            onValueChanged(e) {
                let newValue = metricField.numberFormat() ?? metricField.metricContainer.metricObject.format;
                if (newValue === FieldFormatEnum.Currency) {
                    metricField.accountingStyle(true);
                }
                else if (newValue === FieldFormatEnum.Numeric) {
                    metricField.accountingStyle(false);
                }

                if (newValue == FieldFormatEnum.Currency || newValue == FieldFormatEnum.Percentage) {
                    metricField.decimalPlaces(2);
                }
                else {
                    metricField.decimalPlaces(0);
                }
                if (metricField.metricContainer.isExpression) {
                    metricField.metricContainer.metricExpression.format = newValue;
                }
            },
        };

        self.accountingStyleConfig = {
            value: metricField.accountingStyle as any,
            items: [
                { value: null, text: "Based on Metric" },
                { value: true, text: "On" },
                { value: false, text: "Off" }
            ],
            displayExpr: 'text',
            valueExpr: 'value',
            width: 120,
            height: 24
        };

        self.decimalPlacesParams = {
            value: metricField.decimalPlaces,
            metricField: metricField,
            basedOnMetricValue: null,
        };

        self.formattingRuleSettingParams = {
            id: metricField.formattingRule,
            onSelected() {
                metricField.useFormattingRuleFromMetric(false);
            },
            onClear() {
                metricField.useFormattingRuleFromMetric(false);
            }
        };

        self.backgroundColorParams = {
            color: metricField.backgroundColor,
            appendTo: "parent",
        };

        self.foreColorParams = {
            color: metricField.foreColor,
            appendTo: "parent",
        };

        self.partitionBySwitchConfig = {
            value: field.partitionBy as any,
            height: 24,
            hint: 'Partition By for TSUM metric',
            onValueChanged(e) {//IRNG-2638
                field._partitionBy(e.value);
            }
        };

        self.thresholdValueNumberBoxConfig = {
            value: metricField.thresholdValue as any,
            width: 60,
            height: 24,
            format: 'decimal'
        };

        self.thresholdColorParams = {
            color: metricField.thresholdColor,
            appendTo: "parent",
        };

        let isRankFunction = ko.computed(function () {
            return metricField.metricContainer?.functionType() == FunctionTypeEnum.Rank;
        });

        self.showTotalValueSwitchConfig = {
            value: metricField.showTotalValue as any,
            height: 24,
            disabled: isRankFunction as any,
        };

        self.showSubtotalValueSwitchConfig = {
            value: metricField.showSubtotalValue as any,
            height: 24,
            disabled: isRankFunction as any,
        };

        self.titleAlignSelectBoxConfig = {
            value: metricField.titleAlign,
            displayExpr: 'text',
            valueExpr: 'id',
            width: 80,
            items: [
                { id: 0, text: 'Auto' },
                { id: 1, text: 'Left' },
                { id: 2, text: 'Center' },
                { id: 3, text: 'Right' }
            ],
            height: 24,
        };

        self.valuesAlignSelectBoxConfig = {
            value: metricField.valuesAlign,
            displayExpr: 'text' ,
            valueExpr: 'id' ,
            width: 80,
            items: [
                { id: 0, text: 'Auto' },
                { id: 1, text: 'Left' },
                { id: 2, text: 'Center' },
                { id: 3, text: 'Right' }
            ],
            height: 24,
        };

        self.modeSelectBoxConfig = {
            value: metricField.visualizationModeDefinition?.visualizationMode,
            displayExpr: 'text',
            valueExpr: 'value',
            width: 120,
            items: [
                { value: VisualizationModeEnum.Value, text: "Value" },
                { value: VisualizationModeEnum.BarChart, text: "Bar Chart" }
            ],
            height: 24,
        };

        self.barChartTextSelectBox = {
            value: metricField.visualizationModeDefinition?.barChartText,
            displayExpr: 'text',
            valueExpr: 'value',
            width: 120,
            items: [
                { value: BarChartTextEnum.None, text: "None" },
                { value: BarChartTextEnum.Value, text: "Value" },
                { value: BarChartTextEnum.Percentage, text: "Percentage" }
            ],
            height: 24,
        };

        self.barChartTextPositionSelectBox = {
            value: metricField.visualizationModeDefinition?.barChartTextPosition,
            displayExpr: 'text',
            valueExpr: 'value',
            width: 120,
            items: [
                { value: BarChartTextPositionEnum.Begin, text: "Begin" },
                { value: BarChartTextPositionEnum.Center, text: "Center" },
                { value: BarChartTextPositionEnum.End, text: "End" }
            ],
            height: 24,
        };

        self.barChartColorParams = {
            color: metricField.visualizationModeDefinition?.color,
            appendTo: "parent",
        };

        self.barChartNegativeColorParams = {
            color: metricField.visualizationModeDefinition?.negativeColor,
            appendTo: "parent",
        };

        self.visibleSwitchConfig = {
            value: metricField.visible as any,
            height: 24,
        };

        let chartDefinition = reportConfig.chartDefinition;
        let disableYAxisOptions = !self.isChart || (chartDefinition.chartType() === ChartType.Donut || chartDefinition.chartType() === ChartType.Pie || chartDefinition.chartType() === ChartType.Polar || chartDefinition.chartType() === ChartType.RadarArea);

        self.yAxisSwitchConfig = {
            value: metricField.yAxisChartDefinition?.yAxisID() !== "y-left",
            height: 24,
            switchedOffText: "Left",
            switchedOnText: "Right",
            disabled: disableYAxisOptions,
            width: 60,
            onValueChanged(e) {
                metricField.yAxisChartDefinition.yAxisID(e.value ? "y=right" : "y-left");
            },
        };

        self.chartTypeSelectBoxConfig = Ir.Components.Workbook.Settings.ChartSettings.getChartTypeConfig(metricField.yAxisChartDefinition?.chartType, true);        
        self.chartTypeSelectBoxConfig.disabled = chartDefinition?.chartType() !== ChartType.Mixed;
        
        self.serieColorParams = {
            color: metricField.color,
            appendTo: "parent",
            disabled: ko.computed(function() { 
                let allowColorPerSerie = self.isChart && groupFields().length == 0 && chartDefinition?.chartType() !== ChartType.Pie /*&& chartDefinition.chartType() !== ChartType.PolarArea*/;
                return !allowColorPerSerie || !chartDefinition.colorPerSerie()
            }),
        };

        self.serieStackGroupConfig = {
            format: '#0',
            value: metricField.yAxisChartDefinition?.stackGroup as any,
            disabled: ko.computed(function() { 
                return !(self.isChart && groupFields().length == 0 && (chartDefinition?.chartType() === ChartType.StackedArea || chartDefinition?.chartType() === ChartType.StackedBar || chartDefinition?.chartType() === ChartType.HorizontalBarStacked)); 
            }) as any,
            step: 1,
            showSpinButtons: isMobile() ? false : true,
            min: 0,
            max: 100,
            width: 55
        };

        self.serieBubbleSelectBox = {
            value: metricField.yAxisChartDefinition?.bubbleType,
            displayExpr: 'text',
            valueExpr: 'value',
            width: 120,
            items: [
                { value: BubbleScatterType.YAxis, text: "Y-Axis", icon: "handlevertical" },
                { value: BubbleScatterType.XAxis, text: "X-Axis", icon: "handlehorizontal" },
                { value: BubbleScatterType.BubbleSize, text: "Bubble Size", icon: "isnotblank" }
            ],
            height: 24,
            disabled: ko.computed(function() { 
                return !(self.isChart && chartDefinition?.chartType() === ChartType.Bubble); 
            }) as any,
            fieldTemplate(data, container) {
                const result = $(`<i class="dx-icon-${data.icon} icon-margin"></i><div class="tb"></div>`);
                $(result[1]).dxTextBox({
                        value: data && data?.text,
                        readOnly: true,
                    });
                container.append(result);
            },
            onValueChanged(e) {
                let bubbleType: BubbleScatterType = e.value;
                if (bubbleType === BubbleScatterType.XAxis || bubbleType === BubbleScatterType.BubbleSize) {
                    let field = reportConfig.metricFields().find(x => x.yAxisChartDefinition.bubbleType() == bubbleType && x.queryName !== metricField.queryName);
                    if (field) {
                        field.yAxisChartDefinition.bubbleType(BubbleScatterType.YAxis);
                    }
                }
            }
        };

        self.serieScatterSelectBox = {
            value: metricField.yAxisChartDefinition?.scatterType,
            displayExpr: 'text',
            valueExpr: 'value',
            width: 120,
            items: [
                { value: BubbleScatterType.YAxis, text: "Y-Axis", icon: "handlevertical" },
                { value: BubbleScatterType.XAxis, text: "X-Axis", icon: "handlehorizontal" },
            ],
            height: 24,
            disabled: ko.computed(function() { 
                return !(self.isChart && chartDefinition?.chartType() === ChartType.Scatter); 
            }) as any,
            fieldTemplate(data, container) {
                const result = $(`<i class="dx-icon-${data.icon} icon-margin"></i><div class="tb"></div>`);
                $(result[1]).dxTextBox({
                        value: data && data?.text,
                        readOnly: true,
                    });
                container.append(result);
            },
            onValueChanged(e) {
                let scatterType: BubbleScatterType = e.value;
                if (scatterType === BubbleScatterType.XAxis) {
                    let field = reportConfig.metricFields().find(x => x.yAxisChartDefinition.scatterType() == scatterType && x.queryName !== metricField.queryName);
                    if (field) {
                        field.yAxisChartDefinition.scatterType(BubbleScatterType.YAxis);
                    }
                }
            }
        };
    }

    function functionOptions() {
        let field = koField();

        let options = [
            { value: FunctionTypeEnum.Normal, text: "Normal" },
            { value: FunctionTypeEnum.PercentOfTotal, text: "Percent of Total" },
            { value: FunctionTypeEnum.AccumulatedAll, text: "Accumulated All" }
        ];

        if (field.groupingType() !== GroupingTypeEnum.DSUM && field.groupingType() !== GroupingTypeEnum.WDSUM) {
            options.push({ value: FunctionTypeEnum.Rank, text: "Rank" });
        }

        if (widgetType === WidgetType.Pivot) {
            options.push({ value: FunctionTypeEnum.Accumulated, text: "Accumulated" });
            options.push({ value: FunctionTypeEnum.PercentOfRowTotal, text: "Percent of Row Total" });
            options.push({ value: FunctionTypeEnum.PercentOfRowGrandTotal, text: "Percent of Row Grand Total" });
            options.push({ value: FunctionTypeEnum.PercentOfColumnTotal, text: "Percent of Column Total" });
            options.push({ value: FunctionTypeEnum.PercentOfColumnGrandTotal, text: "Percent of Column Grand Total" });
            options.push({ value: FunctionTypeEnum.AbsoluteVariation, text: "Absolute Variation" });
            options.push({ value: FunctionTypeEnum.PercentVariation, text: "Percent Variation" });
        }
        else if (widgetType === WidgetType.Chart) {
            options.push({ value: FunctionTypeEnum.Accumulated, text: "Accumulated" });
        }

        if (field.groupingType() === GroupingTypeEnum.TSUM) {
            return [{ value: FunctionTypeEnum.Normal, text: "Normal" }];
        }

        return options;
    }

    function createPopover(config: IShowParams) {
        //When the popover is added, it added a padding-right: 17px... We need to remove it
        $("body").addClass("zeroPaddingRight");

        let popoverOptions = {
            position: "left",
            showTitle: true,
            width: 300,
            maxHeight: "95%",
            enableBodyScroll: false,
            wrapperAttr: {
                class: "report-field-designer-properties-popover"
            },
            onInitialized(e) {
                popoverComponent = e.component;
                popoverComponent.option("title", koField().displayNameForDesigner as any);
                popoverComponent.show(config.$target);
            },
            toolbarItems: [
                {
                    widget: "dxButton",
                    location: "after",
                    options: {
                        icon: "revert",
                        hint: "Restore the comparison metrics",
                        visible: restoreComparisonMetricsVisible,
                        onClick(e) {
                            Ir.Components.ReportDesigner.ReportDesigner.addComparisonMetrics(koField() as MetricField, config.reportDesigner);
                        },
                    }
                }
            ],
            onHidden(e) {
                $("body").removeClass("zeroPaddingRight");
                onHidden?.();
            }
        } as DevExpress.ui.dxPopover.Properties;

        let $popover = $(`<div data-bind="dxPopover: popoverOptions">
            <!-- ko if: field -->
                <report-field-designer-properties params="field: field"></report-field-designer-properties>
            <!-- /ko -->
        </div>`);
        $popover.appendTo('body');

        ko.applyBindings({ popoverOptions, field: koField }, $popover[0]);
    }
}